import { ArrowUpCircle } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconArrowCircle(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ArrowUpCircle />
    </IconWrapper>
  );
}
